import request from '@/utils/request'

/**
 * CDN 域名配置接口（后台）
 *   /cdn/domain/page        分页
 *   /cdn/domain             新增(POST) / 修改(PUT) / 删除(DELETE, body 传 id 数组)
 *   /cdn/domain/{id}        详情
 *   /cdn/domain/{id}/status 修改状态(status=0未生效/1生效，query 参数)
 */

// 状态枚举
export const CDN_STATUS = {
  DISABLED: 0, // 未生效
  ENABLED: 1 // 生效
}

export const CDN_STATUS_MAP = {
  0: '未生效',
  1: '生效'
}

// 分页
export function getCdnDomainPage (params) {
  return request({
    url: '/cdn/domain/page',
    method: 'get',
    params
  })
}

// 详情
export function getCdnDomain (id) {
  return request({
    url: `/cdn/domain/${id}`,
    method: 'get'
  })
}

// 新增
export function addCdnDomain (data) {
  return request({
    url: '/cdn/domain',
    method: 'post',
    data
  })
}

// 修改
export function updateCdnDomain (data) {
  return request({
    url: '/cdn/domain',
    method: 'put',
    data
  })
}

// 修改状态
export function updateCdnDomainStatus (id, status) {
  return request({
    url: `/cdn/domain/${id}/status`,
    method: 'put',
    params: { status }
  })
}

// 删除（body 传 id 数组）
export function deleteCdnDomain (ids) {
  return request({
    url: '/cdn/domain',
    method: 'delete',
    data: ids
  })
}
